<template>
    <a class="button-next" @click="next" v-show="contBtn">
      <img src="media/global/btn_continue.png"/>
      <div class="button-title">{{items.globalButtons.continueButton}}</div>
    </a>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    computed: {
      location () {
        return this.$store.state.scormLMS.location
      },
      items() {
        return this.$store.state.items
      },
      contBtn() {
        return this.$store.state.contBtn
      }
    },
    methods: {
      next() {
        this.$store.commit('scormLMS/locationPlus');
      }
    },
    components: {},
    props: []
  }

</script>

<style scoped>
.button-next {
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 990;
  cursor: pointer;
  user-select: none;
  -webkit-filter: drop-shadow(1.5px 1.5px 1px #222 );
  filter: drop-shadow(1.5px 1.5px 1px #222);
}
.button-next.disabled {
  display: none;
  pointer-events: none;
}
.button-title {
  font-family: 'Nunito';
  position: absolute;
  bottom: 4px;
  right: 26px;
  z-index: 999;
  font-size: 13px;
  text-decoration: none;
  color: black;
}

@media only screen and (max-width: 750px) {
  .button-next {
    bottom: 5px;
    right: 5px;
  }

  .button-title {

  }
}

</style>



// WEBPACK FOOTER //
// ButtonNext.vue?4ed00e53